const PortalDefaultStateObject = {
  user: {
    id: 0,
    uid: '',
    userName: '',
    nickName: '',
    authorizations: {},
    loggedIn: false,
    validLicense: false,
  },
  main: {
    protocolDetected: false,
    ready: false,
    announcements: [
      {
        title: 'Need Technical Help?',
        content: 'Visit our support page for videos and a knowledge base.',
        action: {
          label: 'Support',
          href: 'https://www.beyondlabz.com/support',
        },
        backgroundUrl: 'https://images.squarespace-cdn.com/content/v1/5cc20dc04d546e365737240b/1571310880743-U1VQR2TY3KZK12WFEOUX/ke17ZwdGBToddI8pDm48kPTrHXgsMrSIMwe6YW3w1AZ7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z4YTzHvnKhyp6Da-NYroOW3ZGjoBKy3azqku80C789l0k5fwC0WRNFJBIXiBeNI5fKTrY37saURwPBw8fO2esROAxn-RKSrlQamlL27g22X2A/chem+background.jpg?format=2500w',
      },
      {
        title: 'YouTube',
        content: 'Visit our YouTube channel for examples of experiments and other useful information.',
        action: {
          label: 'YouTube',
          href: 'https://www.youtube.com/channel/UCyFuckoJR_M7gy5OVqg5vYw/playlists',
        },
        backgroundUrl: 'https://images.squarespace-cdn.com/content/v1/5cc20dc04d546e365737240b/1571310948999-DFJBUDLDBPW9HWUI10GS/ke17ZwdGBToddI8pDm48kPTrHXgsMrSIMwe6YW3w1AZ7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z4YTzHvnKhyp6Da-NYroOW3ZGjoBKy3azqku80C789l0k5fwC0WRNFJBIXiBeNI5fKTrY37saURwPBw8fO2esROAxn-RKSrlQamlL27g22X2A/PhysicsBackground.jpg?format=2500w',
      },
      {
        title: 'Beyond Labz Community',
        content: 'Visit the Beyond Labz Community for forums and a place to share ideas and experiences.',
        action: {
          label: 'Community',
          href: 'https://community.beyondlabz.com',
        },
        backgroundUrl: 'https://images.squarespace-cdn.com/content/v1/5cc20dc04d546e365737240b/1571310979283-HQKBU50HOSX5V4L4OPEV/ke17ZwdGBToddI8pDm48kPTrHXgsMrSIMwe6YW3w1AZ7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z4YTzHvnKhyp6Da-NYroOW3ZGjoBKy3azqku80C789l0k5fwC0WRNFJBIXiBeNI5fKTrY37saURwPBw8fO2esROAxn-RKSrlQamlL27g22X2A/Physical%2BScience.jpg?format=2500w',
      },
    ],
  },
  labs: {
    online: false,
    authorizations: {
      chemistry: false,
      organic: false,
      biology: false,
      physics: false,
      physical_science: false,
    },
    apps: [{
      id: 0,
      installed: false,
      versionNumber: '4.6.1',
      versionLabel: '4.6.1.2',
      description: 'Virtual ChemLab 4.6: A set of sophisticated and realistic simulations covering Inorganic, Gases, Quantum, Calorimetry and Titrations.  After installation, access the Help Menu in the main laboratory for tips on getting started.',
      copyright: 'Copyright 1998-2020: Brigham Young University and Beyond Labz',
      edition: 3,
      availableEditions: [2, 3],
      knownBy: {
        name: 'Chemistry',
        short: 'chemistry',
        alternate: 'virtual_chemlab',
      },
      status: {
        state: 2,
        percentage: 0,
      },
    },
    {
      id: 1,
      installed: false,
      versionNumber: '4.6.2',
      versionLabel: '4.6.1.2',
      description: 'Virtual ChemLab Organic 4.6: A set of sophisticated and realistic simulations covering Organic Chemistry.  After installation, access the Help Menu in the main laboratory for tips on getting started.',
      copyright: 'Copyright 1998-2020: Brigham Young University and Beyond Labz',
      edition: 3,
      availableEditions: [3],
      knownBy: {
        name: 'Organic Chemistry',
        short: 'organic',
        alternate: 'virtual_chemlab_organic',
      },
      status: {
        state: 0,
        percentage: 0,
      },
    },
    {
      id: 2,
      installed: false,
      versionNumber: '4.6.1',
      versionLabel: '4.6.1.2',
      description: 'Virtual Biology 4.6: A set of sophisticated and realistic simulations covering Microscopy, Molecular Biology, Genetics, Ecology, and Systematics and Taxonomy. After installation, access the Help Menu in the main laboratory for tips on getting started.',
      copyright: 'Copyright 1998-2019: Brigham Young University and Beyond Labz',
      edition: 3,
      availableEditions: [2, 3],
      knownBy: {
        name: 'Biology',
        short: 'biology',
        alternate: 'virtual_biology',
      },
      status: { state: 0, percentage: 0 },
    },
    {
      id: 3,
      installed: false,
      versionNumber: '4.6.1',
      versionLabel: '4.6.1.1',
      description: 'Virtual Physics Lab 4.6: A set of sophisticated and realistic simulations covering Circuits, Density, Mechanics and Optics.  After installation, access the Help Menu in the main laboratory for tips on getting started.',
      copyright: 'Copyright 1998-2019: Brigham Young University and Beyond Labz',
      edition: 3,
      availableEditions: [2, 3],
      knownBy: {
        name: 'Physics',
        short: 'physics',
        alternate: 'virtual_physics',
      },
      status: { state: 0, percentage: 0 },
    },
    {
      id: 4,
      installed: false,
      versionNumber: '4.6.1',
      versionLabel: '4.6.1.1',
      description: 'Virtual Physical Science Lab 4.6: A set of sophisticated and realistic simulations covering Circuits, Density, Mechanics and Optics.  After installation, access the Help Menu in the main laboratory for tips on getting started.',
      copyright: 'Copyright 1998-2019: Brigham Young University and Beyond Labz',
      edition: 1,
      availableEditions: [1, 2],
      knownBy: {
        name: 'Physical Science',
        short: 'physical_science',
        alternate: 'virtual_physical_science',
      },
      status: {
        state: 0,
        percentage: 0,
      },
    }],
    timeStamp: {
      currentTimestamp: 0,
      validUntil: 0,
    },
    userPrefences: {
      editions: {
        chemistry: 1,
        organic: 1,
        biology: 1,
        physics: 1,
        physical_science: 1,
      },
    },
  },
};

export default PortalDefaultStateObject;
